import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import GeneralDialog from "../GeneralDialog";
import Utilty from "../../../Utility";
import ConditionalComponent from "../../Shared/ConditionalComponent";


const SurveyPopUp = observer(() => {
    const {modalStore, generalStore, surveyStore} = useStores();

    const [surveyName, setSurveyName] = useState(
        ""
    );

    const trimmedName = surveyName.trim();
    const skipSurvey = async() => {
        await surveyStore.skipSurvey()

    }
    const openSurvey = () => {
        modalStore.isSurveyOpen = true
        modalStore.isSurveyPopupOpen = false
    }

    const renderBody = () => {
        return (
            <div
                className="flex flex-col items-center justify-start font-sans text-main-normal bg-background-normal"
                style={{
                    width: '100%',
                    maxWidth: '479px',
                    paddingLeft: 31,
                    paddingRight: 31,
                    paddingTop: 25,
                    paddingBottom: 25,
                    gap: 26,
                    borderRadius: 10,
                    outline: '1px var(--navigationbar-normal-color) solid',
                    outlineOffset: '-1px',
                    boxShadow: '1px 1px 10px rgba(0,0,0,0.15)',
                    display: 'inline-flex',
                }}
            >
                <div
                    className="flex flex-col items-center justify-center text-center font-bold"
                    style={{
                        width: '100%',
                        fontSize: 24,
                        fontFamily: 'Open Sans',
                        wordWrap: 'break-word',
                    }}
                >
                    {surveyStore.currentSurvey.surveyName} - survey
                </div>

                <div className="flex flex-col items-start justify-start">
                    <div
                        className="flex flex-col items-center justify-center text-center font-normal text-main-normal"
                        style={{
                            fontSize: 14,
                            wordWrap: 'break-word',
                        }}
                    >
                        Your input will help us improve the {surveyStore.currentSurvey.surveyName?.length > 0 ?? surveyStore.currentSurvey.surveyName.toLowerCase()} experience.
                        <br />
                        Please take a minute to answer a few questions anonymously
                    </div>
                </div>

                <div
                    className="inline-flex items-center justify-center"
                    style={{ gap: 24, alignSelf: 'stretch' }}
                >
                    <div
                        className="flex items-center justify-center cursor-pointer"
                        style={{
                            height: 32,
                            paddingLeft: 32,
                            paddingRight: 32,
                            paddingTop: 8,
                            paddingBottom: 8,
                            borderRadius: 25,
                            gap: 10,
                        }}
                        onClick={skipSurvey}
                    >
                        <div
                            className="text-xs font-normal text-classic-button-normal font-sans"
                            style={{
                                fontFamily: 'Open Sans',
                                wordWrap: 'break-word',
                            }}
                        >
                            Skip survey
                        </div>
                    </div>

                    <div
                        className="flex items-center justify-center cursor-pointer rounded-button bg-classic-button-normal hover:bg-classic-button-hover active:bg-classic-button-active-color"
                        style={{
                            paddingLeft: 12,
                            paddingRight: 12,
                            paddingTop: 8,
                            paddingBottom: 8,
                            gap: 6,
                        }}
                        onClick={openSurvey}
                    >
                        <div
                            className="text-xs font-normal text-classic-button-normal-text"
                            style={{
                                fontFamily: 'Open Sans',
                                wordWrap: 'break-word',
                            }}
                        >
                            Open short survey
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const onEnter = () => setSurveyName(surveyStore.currentSurvey.surveyName || "");

    return (Utilty.isMobile() ?
            <ConditionalComponent if={modalStore.isSurveyPopupOpen}>
                <div
                    className="fixed inset-0 bg-background-overlay flex justify-center items-start overflow-auto h-screen"
                    style={{ zIndex: 2002 }}
                >

                    <div
                        className="fixed inset-0 flex justify-center items-start mx-[5vw] mt-[30vh]"
                        style={{ zIndex: 2002 }}
                    >
                        {renderBody()}
                    </div>
                </div>

            </ConditionalComponent>
            :
        <GeneralDialog
            maxWidth={false}
            fullWidth
            maxHeight
            openControl="isSurveyPopupOpen"
            dialogStyle={{ backgroundColor: 'transparent', boxShadow: 'none', display: 'flex', justifyItems:'center', alignItems: 'center'}}
            onEnter={onEnter}
            body={renderBody()}
            specialOnClose={skipSurvey}
            isConfirmDisabled
        />
    );
});

export default SurveyPopUp;
